import { Spark } from "./Primitives";
import { useT } from "@/lib/i18n";

export const Marquee = () => {
  const items = useT().marquee;
  const row = [...items, ...items];
  return (
    <section className="py-10 md:py-14 border-y border-[var(--line)] overflow-hidden" data-testid="marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((it, i) => (
              <span key={i} className="flex items-center gap-8 md:gap-12 pr-8 md:pr-12">
                <span className={`font-display text-5xl md:text-8xl font-light whitespace-nowrap ${i % 2 ? "italic text-transparent outline-text" : ""}`}>{it}</span>
                <Spark className="w-6 h-6 md:w-8 md:h-8 text-[var(--gold)] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
